const MuiFormControlLabel = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      color: theme.palette.grey[800],
      gap: "11px",
      margin: 0,
      ...ownerState.labelAlign === "bottom" && {
        alignItems: "start"
      }
    })
  }
};
export {
  MuiFormControlLabel
};
